import { render, staticRenderFns } from "./CompanyDataUpdateFormsDetails.vue?vue&type=template&id=1402d027&scoped=true&"
import script from "./CompanyDataUpdateFormsDetails.vue?vue&type=script&lang=js&"
export * from "./CompanyDataUpdateFormsDetails.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDataUpdateFormsDetails.vue?vue&type=style&index=0&id=1402d027&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1402d027",
  null
  
)

export default component.exports